import ABPCardSelectorImg from "../components/UmmIApps/Cards/ABPCardSelectorImg.png";
import ActividadesAplicacionCardImg from "../components/UmmIApps/Cards/ActividadesAplicacionCardImg.png";
import AutoCoevaluacionCardImg from "../components/UmmIApps/Cards/AutoCoevaluacionCardImg.png";
import UmmIAPediaCardImg from "../components/UmmIApps/Cards/ChatExpertoCardImg.png";
import ClaseActivaCardImg from "../components/UmmIApps/Cards/ClaseActivaCardImg.png";
import ConcepcionesErroneasCardImg from "../components/UmmIApps/Cards/ConcepcionesErroneasCardImg.png";
import ConexionesVidaRealCardImg from "../components/UmmIApps/Cards/ConexionesVidaRealCardImg.png";
import ConocimientosPreviosCardImg from "../components/UmmIApps/Cards/ConocimientosPreviosCardImg.png";
import DesignThinkingCardImg from "../components/UmmIApps/Cards/DesignThinkingCardImg.png";
import GuiaAprendizajeCardImg from "../components/UmmIApps/Cards/GuiaAprendizajeCardImg.png";
import GuiaAprendizajellCardImg from "../components/UmmIApps/Cards/GuiaAprendizajellCardImg.png";
import InformeDesempenoCardImg from "../components/UmmIApps/Cards/InformeDesempenoCardImg.png";
import JuegosEnCasaCardImg from "../components/UmmIApps/Cards/JuegosEnCasaCardImg.svg";
import ListaCotejoCardImg from "../components/UmmIApps/Cards/ListaCotejoCardImg.png";
import LudicaYJuegosCardImg from "../components/UmmIApps/Cards/LudicaYJuegosCardImg.png";
import MensajeApoderadoCardImg from "../components/UmmIApps/Cards/MensajeApoderadoCardImg.png";
import PersonalizaExperienciasAprendizajeCardImg from "../components/UmmIApps/Cards/PersonalizaExperienciasAprendizajeCardImg.png";
import PlanificacionDiferenciadaCardImg from "../components/UmmIApps/Cards/PlanificacionDiferenciada.png";
import PreguntasPensamientoCriticoCardImg from "../components/UmmIApps/Cards/PreguntasPensamientoCriticoCardImg.png";
import PruebaConocimientoCardImg from "../components/UmmIApps/Cards/PruebaConocimientoCardImg.png";
import ResponderCorreoCardImg from "../components/UmmIApps/Cards/ResponderCorreoCardImg.png";
import RubricaEvaluacionCardImg from "../components/UmmIApps/Cards/RubricaEvaluacionCardImg.png";
import RuletaDeJuegosCardImg from "../components/UmmIApps/Cards/RuletaDeJuegosCardImg.png";
import TallerAprendizajeCardImg from "../components/UmmIApps/Cards/TallerAprendizajeCardImg.png";
import TareaCardImg from "../components/UmmIApps/Cards/TareaCardImg.png";
import TicketSalidaCardImg from "../components/UmmIApps/Cards/TicketSalidaCardImg.png";
import UnidadTematicaCardSelectorImg from "../components/UmmIApps/Cards/UnidadTematicaCardSelectorImg.png";
import {
  DBComponente,
  iDataComponentes,
} from "../interfaces/SuperAdmin/Others/iDataComponentes";
import { Estado } from "../interfaces/SuperAdmin/Others/iDataEstado";
import ABPPage from "../pages/UmmIApps/ABPPage";
import ActividadesAplicacionPage from "../pages/UmmIApps/ActividadesAplicacionPage";
import AutoCoevaluacionPage from "../pages/UmmIApps/AutoCoevaluacionPage";
import ChatBedrockPage from "../pages/UmmIApps/ChatBedrockPage";
import ClaseActivaPage from "../pages/UmmIApps/ClaseActivaPage";
import ClaseActivaPeruPage from "../pages/UmmIApps/ClaseActivaPeruPage";
import ClaseDiferenciadaPage from "../pages/UmmIApps/ClaseDiferenciadaPage";
import ConcepcionesErroneasPage from "../pages/UmmIApps/ConcepcionesErroneasPage";
import ConocimientosPreviosPage from "../pages/UmmIApps/ConocimientosPreviosPage";
import DesignThinkingPage from "../pages/UmmIApps/DesignThinkingPage";
import GenerarConexionesPage from "../pages/UmmIApps/GenerarConexionesPage";
import GuiaAprendizajePage from "../pages/UmmIApps/GuiaAprendizajePage";
import GuiaAprendizajellPage from "../pages/UmmIApps/GuiaAprendizajellPage";
import InformeDesempenoPage from "../pages/UmmIApps/InformeDesempenoPage";
import JuegosCasaFluidezLectora from "../pages/UmmIApps/JuegosCasaFluidezLectoraPage";
import ListaCotejoPage from "../pages/UmmIApps/ListaCotejoPage";
import LudicaYJuegosPage from "../pages/UmmIApps/LudicaYJuegosPage";
import MensajeApoderadoPage from "../pages/UmmIApps/MensajeApoderadoPage";
import NuevoABPPage from "../pages/UmmIApps/NuevoABPPage";
import PersonalizaExperienciasAprendizajePage from "../pages/UmmIApps/PersonalizaExperienciasAprendizajePage";
import PreguntasPensamientoCriticoPage from "../pages/UmmIApps/PreguntasPensamientoCriticoPage";
import PruebaConocimientoPage from "../pages/UmmIApps/PruebaConocimientoPage";
import ResponderCorreoPage from "../pages/UmmIApps/ResponderCorreoPage";
import RubricaEvaluacionPage from "../pages/UmmIApps/RubricaEvaluacionPage";
import RuletaJuegosPage from "../pages/UmmIApps/RuletaJuegosPage";
import TallerAprendizajePage from "../pages/UmmIApps/TallerAprendizajePage";
import TareaPage from "../pages/UmmIApps/TareaPage";
import TicketSalidaPage from "../pages/UmmIApps/TicketSalidaPage";
import UnidadTematicaPage from "../pages/UmmIApps/UnidadTematicaPage";

const ummiapps: iDataComponentes[] = [
  {
    id_componente: "6c28a1b7-0467-4411-9e71-3dad18e06160",
    nombre: "Unidad Temática",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara una secuencia de clases en torno a los objetivos de aprendizaje seleccionados",
    route: "unidadtematica",
    tipoEstructura: "unidad_activa",
    img: UnidadTematicaCardSelectorImg,
    alt: "Imagen unidad temática",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <UnidadTematicaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "1e50e2fd-1e39-4d6c-9df9-eecd30b4f191",
    nombre: "Proyecto ABP",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara un proyecto interdisciplinario conectado con tus estudiantes y tu escuela",
    route: "abp",
    tipoEstructura: "aprendizaje_basado_en_proyectos",
    img: ABPCardSelectorImg,
    alt: "Imagen ABP",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ABPPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "1e50e2fd-1e39-4d6c-9df9-eecd30b4f191",
    nombre: "Proyecto ABP BETA",
    categoria: "UmmIAPlan",
    descripcion:
      "Aprendizaje basado en proyectos beta ",
    route: "abpbeta",
    tipoEstructura: "aprendizaje_basado_en_proyectos",
    img: ABPCardSelectorImg,
    alt: "Imagen ABP",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento:  <NuevoABPPage/>,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "7ff222f3-557f-464f-84a7-343205e0f4a1",
    nombre: "Clase Diferenciada",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara una clase considerando las caracteristicas y necesidades en los estudiantes",
    route: "clasediferenciada",
    tipoEstructura: "planificacion",
    img: PlanificacionDiferenciadaCardImg,
    alt: "Imagen unidad temática",
    pais: ["CL", "ARG"],
    elemento: <ClaseDiferenciadaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "7ff222f3-557f-464f-84a7-343205e0f4a1",
    nombre: "Planeación para la inclusión (Decreto 1421)",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara una clase considerando las caracteristicas y necesidades en los estudiantes",
    route: "clasediferenciada",
    tipoEstructura: "planificacion",
    img: PlanificacionDiferenciadaCardImg,
    alt: "Imagen unidad temática",
    pais: ["CO"],
    elemento: <ClaseDiferenciadaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "94e802d7-d28b-443a-8e62-5ea2c96168a9",
    nombre: "Clase Activa",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara una clase que ponga en el centro el protagonismo de tus estudiantes",
    route: "claseactiva",
    tipoEstructura: "planificacion_clase_activa",
    img: ClaseActivaCardImg,
    alt: "Imagen clase activa",
    pais: ["CL", "CO", "ARG", "UY"],
    elemento: <ClaseActivaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "94e802d7-d28b-443a-8e62-5ea2c96168a9",
    nombre: "Clase Activa",
    categoria: "UmmIAPlan",
    descripcion:
      "Prepara una clase que ponga en el centro el protagonismo de tus estudiantes",
    route: "claseactivaperu",
    tipoEstructura: "planificacion_clase_activa",
    img: ClaseActivaCardImg,
    alt: "Imagen clase activa",
    pais: ["PE"],
    elemento: <ClaseActivaPeruPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "8a4ae0e4-4bfc-41f0-a2f8-5e434fec6142",
    nombre: "Pensamiento de diseño (Design Thinking)",
    categoria: "UmmIAPlan",
    descripcion:
      "Diseña experiencias para que tus estudiantes resuelvan problemas de manera creativa e innovadora",
    route: "designthinking",
    tipoEstructura: "design_thinking",
    img: DesignThinkingCardImg,
    alt: "Imagen pensamiento de diseño",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <DesignThinkingPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "ccbeb91c-0299-4e90-aec0-72248c08bf24",
    nombre: "Personaliza experiencias de aprendizaje",
    categoria: "UmmIAPlan",
    descripcion:
      "Ajusta y enriquece tus actividades para que se alineen con el contexto y las necesidades de tus estudiantes.",
    route: "personalizaexperienciasaprendizaje",
    tipoEstructura: "guia_aprendizajea",
    img: PersonalizaExperienciasAprendizajeCardImg,
    alt: "Imagen experiencias de aprendizaje",
    pais: ["CO"],
    elemento: <PersonalizaExperienciasAprendizajePage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "de6a9f4f-aee7-4e6e-9b13-0767cd60334c",
    nombre: "Conexiones con la vida real",
    categoria: "UmmIAClase",
    descripcion:
      "Conecta el contenido curricular con situaciones reales para mostrar su utilidad",
    route: "generarconexiones",
    tipoEstructura: "conexiones_realidad",
    img: ConexionesVidaRealCardImg,
    alt: "Imagen conexiones con la vida real",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <GenerarConexionesPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "b1687606-4c96-4236-852e-84c0caf8b5c5",
    nombre: "Tarea",
    categoria: "UmmIAClase",
    descripcion:
      "Propón a tus estudiantes un trabajo para fortalecer su aprendizaje",
    route: "tarea",
    tipoEstructura: "tareas_hogar",
    img: TareaCardImg,
    alt: "Imagen tarea",
    pais: ["CL", "PE", "ARG", "UY"],
    elemento: <TareaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "b1687606-4c96-4236-852e-84c0caf8b5c5",
    nombre: "Retos y actividades",
    categoria: "UmmIAClase",
    descripcion:
      "Propón a tus estudiantes un trabajo para fortalecer su aprendizaje",
    route: "tarea",
    tipoEstructura: "tareas_hogar",
    img: TareaCardImg,
    alt: "Imagen tarea",
    pais: ["CO"],
    elemento: <TareaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "e4148b7b-32a4-4c3e-b4dc-b47733e21db7",
    nombre: "Guía de aprendizaje I",
    categoria: "UmmIAClase",
    descripcion:
      "Actividad individual de reflexión y reforzamiento de conocimientos",
    route: "guiaaprendizaje",
    tipoEstructura: "guia_aprendizaje",
    img: GuiaAprendizajeCardImg,
    alt: "Imagen guía de aprendizaje I",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <GuiaAprendizajePage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "ef36ba55-7964-42da-bb86-a26592b66631",
    nombre: "Guía de aprendizaje II",
    categoria: "UmmIAClase",
    descripcion:
      "Actividad grupal de reflexión y reforzamiento de conocimientos",
    route: "guiaaprendizajell",
    tipoEstructura: "guia_aprendizaje2",
    img: GuiaAprendizajellCardImg,
    alt: "Imagen guía de aprendizaje II",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <GuiaAprendizajellPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "68434ed0-8436-4b55-b787-45c10db4001e",
    nombre: "Activación de conocimientos previos",
    categoria: "UmmIAClase",
    descripcion:
      "Actividades para recoger lo que tus estudiantes ya saben o pueden conectar",
    route: "conocimientosprevios",
    tipoEstructura: "conocimientos_previos",
    img: ConocimientosPreviosCardImg,
    alt: "Imagen activación de conocimientos previos",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ConocimientosPreviosPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "84514ad4-0e19-4086-8e03-c2b6aafaf7a0",
    nombre: "Actividades lúdicas y juegos",
    categoria: "UmmIAClase",
    descripcion:
      "Propón a tus alumnos formas lúdicas para fortalecer su aprendizaje",
    route: "ludicayjuegos",
    tipoEstructura: "aprendizaje_ludica",
    img: LudicaYJuegosCardImg,
    alt: "Imagen actividades lúdicas y juegos",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <LudicaYJuegosPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "3954ac6e-6ec2-4eba-91f7-b8c0fa37adcf",
    nombre: "Concepciones erróneas comunes",
    categoria: "UmmIAClase",
    descripcion:
      "Identifica las confusiones comunes y transforma tu manera de enseñar",
    route: "concepcioneserroneas",
    tipoEstructura: "concepciones_erroneas",
    img: ConcepcionesErroneasCardImg,
    alt: "Imagen concepciones erróneas comunes",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ConcepcionesErroneasPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "8f234382-7ebb-403a-acee-3c59f2de3bac",
    nombre: "Preguntas de pensamiento crítico",
    categoria: "UmmIAClase",
    descripcion:
      "Diseña preguntas que estimulen el análisis profundo y la reflexión crítica",
    route: "preguntaspensamientocritico",
    tipoEstructura: "preguntas_pensamiento_critico",
    img: PreguntasPensamientoCriticoCardImg,
    alt: "Imagen preguntas de pensamiento crítico",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <PreguntasPensamientoCriticoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "e5b23092-21d6-426f-85da-c6a0611e446d",
    nombre: "Ticket de Salida",
    categoria: "UmmIAEv",
    descripcion: "Pequeña actividad de aprendizaje para el final de la clase",
    route: "ticketsalida",
    tipoEstructura: "ticket_salida",
    img: TicketSalidaCardImg,
    alt: "Imagen ticket de salida",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <TicketSalidaPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "cc3c8e8f-fc6a-485a-9c03-215ff41bedc0",
    nombre: "Prueba de conocimiento",
    categoria: "UmmIAEv",
    descripcion: "Crea una prueba para conocer el avance de tus estudiantes",
    route: "pruebaconocimiento",
    tipoEstructura: "test",
    img: PruebaConocimientoCardImg,
    alt: "Imagen prueba de conocimiento",
    pais: ["CL", "PE", "ARG", "UY"],
    elemento: <PruebaConocimientoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "cc3c8e8f-fc6a-485a-9c03-215ff41bedc0",
    nombre: "Prueba de aprendizaje",
    categoria: "UmmIAEv",
    descripcion: "Crea una prueba para conocer el avance de tus estudiantes",
    route: "pruebaconocimiento",
    tipoEstructura: "test",
    img: PruebaConocimientoCardImg,
    alt: "Imagen prueba de conocimiento",
    pais: ["CO"],
    elemento: <PruebaConocimientoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "bf314e2e-df6f-4100-bf25-c5a896b43ee3",
    nombre: "Rúbrica de Evaluación",
    categoria: "UmmIAEv",
    descripcion:
      "Crea una rúbrica para evaluar analítica y reflexivamente la cantidad de trabajo de tus estudiantes",
    route: "rubricaevaluacion",
    tipoEstructura: "rubrica",
    img: RubricaEvaluacionCardImg,
    alt: "Imagen rúbrica de evaluación",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <RubricaEvaluacionPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "0538cc95-707a-461d-ac2d-fc83df997919",
    nombre: "Auto y coevaluación",
    categoria: "UmmIAEv",
    descripcion:
      "Crea una experiencia para que los estudiantes se hagan parte de su propia evaluación",
    route: "autocoevaluacion",
    tipoEstructura: "autoevaluacion",
    img: AutoCoevaluacionCardImg,
    alt: "Imagen auto y coevaluación",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <AutoCoevaluacionPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "cf0b66fd-959e-473b-88a6-71f2cadaa5e4",
    nombre: "Listas de cotejo",
    categoria: "UmmIAEv",
    descripcion:
      "Crea una lista de cotejo para verificar de manera objetiva y sistemática el cumplimiento de criterios específicos en el trabajo de tus estudiantes",
    route: "listacotejo",
    tipoEstructura: "cotejo",
    img: ListaCotejoCardImg,
    alt: "Imagen listas de cotejo",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ListaCotejoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "0346c719-96ef-4bd2-994a-27e535c5bc0c",
    nombre: "Actividades de aplicación",
    categoria: "UmmIAEv",
    descripcion:
      "Diseña evaluaciones que fomenten la aplicación del conocimiento en diversos contextos",
    route: "actividadesaplicacion",
    tipoEstructura: "actividades_aplicacion",
    img: ActividadesAplicacionCardImg,
    alt: "Imagen actividades de aplicación",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ActividadesAplicacionPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "617ec153-32bc-4df8-b28e-8d4b1245d9b4",
    nombre: "Mensaje al apoderado",
    categoria: "UmmIACom",
    descripcion:
      "Redacta el mensaje perfecto para comunicarte con padres o cuidadores",
    route: "mensajeapoderado",
    tipoEstructura: "comunicacion",
    img: MensajeApoderadoCardImg,
    alt: "Imagen mensaje al apoderado",
    pais: ["CL"],
    elemento: <MensajeApoderadoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "617ec153-32bc-4df8-b28e-8d4b1245d9b4",
    nombre: "Mensaje a familias",
    categoria: "UmmIACom",
    descripcion:
      "Redacta el mensaje perfecto para comunicarte con las familias",
    route: "mensajeapoderado",
    tipoEstructura: "comunicacion",
    img: MensajeApoderadoCardImg,
    alt: "Imagen mensaje al apoderado",
    pais: ["CO", "PE", "ARG", "UY"],
    elemento: <MensajeApoderadoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "297ee9cb-6973-438e-b734-d71c1088d742",
    nombre: "Responder un correo",
    categoria: "UmmIACom",
    descripcion: "Responde con el mensaje perfecto para comunicar tus ideas",
    route: "respondercorreo",
    tipoEstructura: "contestar_correo",
    img: ResponderCorreoCardImg,
    alt: "Imagen responder un correo",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ResponderCorreoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "145c5c22-135b-4035-87c8-e1c11f70fdcc",
    nombre: "Informe de desempeño",
    categoria: "UmmIACom",
    descripcion:
      "Prepara un perfecto informe de desempeño para cada uno de tus estudiantes",
    route: "informedesempeno",
    tipoEstructura: "informe_desempeno",
    img: InformeDesempenoCardImg,
    alt: "Imagen informe de desempeño",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <InformeDesempenoPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "09c20769-aba8-4d9a-9bcf-174284daf641",
    nombre: "Chat Experto",
    categoria: "UmmIAPedia",
    descripcion:
      "Conversa con una IA entrenada con contenido pedagógico y didáctico",
    route: "chat",
    tipoEstructura: "chat_experto",
    img: UmmIAPediaCardImg,
    alt: "Imagen chat Experto",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <ChatBedrockPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "c404cc0f-b389-41cc-93ac-072630c4f729",
    nombre: "Taller de aprendizaje",
    categoria: "UmmIAPedia",
    descripcion:
      "Prepara un taller para trabajar con tus colegas un tema de interés y crecimiento profesional",
    route: "talleraprendizaje",
    tipoEstructura: "taller_aprendizaje",
    img: TallerAprendizajeCardImg,
    alt: "Imagen taller de aprendizaje",
    pais: ["CL", "PE", "CO", "ARG", "UY"],
    elemento: <TallerAprendizajePage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "21ce429f-4409-467b-91c3-00337df8bc3d",
    nombre: "Ruleta de juegos",
    categoria: "UmmIAHogar",
    descripcion:
      "Aplicaciones y juegos lúdicos para niños que ayudan a fortalecer su aprendizaje.",
    route: "ruletajuegos",
    tipoEstructura: "ruleta",
    img: RuletaDeJuegosCardImg,
    alt: "Imagen ruleta de juegos",
    pais: ["ARG"],
    elemento: <RuletaJuegosPage />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
  {
    id_componente: "a7f4c9b3-5e4b-4cd4-8b1f-bc1249e2dbe7",
    nombre: "Juegos en casa para la fluidez lectora",
    categoria: "UmmIAClase",
    descripcion:
      "Aplicaciones y juegos lúdicos para niños que ayudan a fortalecer su aprendizaje.",
    route: "juegosencasa",
    tipoEstructura: "juegosencasa",
    img: JuegosEnCasaCardImg,
    alt: "Imagen juegos en casa para la fluidez lectora",
    pais: [],
    elemento: <JuegosCasaFluidezLectora />,
    created_at: "",
    updated_at: "",
    valor_creditos: 0,
  },
];
export { ummiapps };

export const getUmmiapps = (
  apps: DBComponente[],
  pais: string
): iDataComponentes[] => {
  if (!apps || !pais) return [];

  let finalApps: iDataComponentes[] = [];

  finalApps = ummiapps.reduce<iDataComponentes[]>((acc, app) => {
    //Descartamos la app si no pertenece a nuestro país
    if (!app.pais.includes(pais as "CL" | "PE" | "CO")) return acc;

    //Chequeamos que la app haya venido de la db
    const foundApp = apps.find((ap) => ap.id_componente === app.id_componente);

    // Si está presente, devolvemos el objeto con la propiedad de valor_creditos de la API
    if (foundApp) {
      acc.push({
        ...app,
        valor_creditos: foundApp.valor_creditos,
      });
    }

    return acc;
  }, []);

  return finalApps;
};
